<div class="snackbar {{style}}" *ngIf="visible" [class.show]="visible">
  <div class="message" [innerHTML]="message"></div>
  <button (click)="close()">X</button>
</div>
